module.exports = __webpack_public_path__ + "files/4c2a86a482068eaf4c6ff1000cd3d5d1.png";